import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { userSelector } from 'store/slices/user';

import { EMAILS } from 'config/organization';

export const useAccessView = () => {
  const userInfo = useSelector(userSelector.getInfo);

  //TODO: remove env checking when B2B tournaments will be needed on prod
  return useMemo(
    () =>
      process.env.REACT_APP_VERSION !== 'prod' &&
      !!userInfo?.email &&
      userInfo.email.includes(EMAILS.tech),
    [userInfo],
  );
};

export default useAccessView;
